export default __webpack_public_path__ + "static/media/ds-busca-subs-js.3ccf3126.png";